import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import ConfirmDialog from './ConfirmDialog';
import TextEditor, { addPlaceholdersHighlight, removePlaceholdersHighlight } from './TextEditor';
import TextArea from './TextArea';
import CheckBox from './CheckBox';
import { userEmailSignatureUpdateAction } from '../../actions/userActions';
import { caseSetServerError } from './../../actions/caseActions';


class EmailSignatureDialog extends PureComponent {

    constructor(props) {
        super(props);
        this.confirm = this.confirm.bind(this);
        this.state = {
            isEmailSignatureRawHtml: false,
            disabled: false,
            emailSignature: '',
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.config && nextProps.config['emailSignature'] !== undefined) {
            const isHtml = !!nextProps.config['isEmailSignatureRawHtml'];
            let emailSignature = nextProps.config['emailSignature'];
            if (!isHtml) {
                emailSignature = addPlaceholdersHighlight(emailSignature, this.props.config, this.props.loggedIn);
            }

            this.setState({
                isEmailSignatureRawHtml: isHtml,
                emailSignature,
            });
        }
    }

    confirm() {
        let emailSignature = this.state.emailSignature;
        const isEmailSignatureRawHtml = this.state.isEmailSignatureRawHtml;
        if (!isEmailSignatureRawHtml) {
            emailSignature = removePlaceholdersHighlight(emailSignature);
        }

        this.setState({disabled: true});
        this.props.dispatch(userEmailSignatureUpdateAction(emailSignature, isEmailSignatureRawHtml))
            .then(() => {
                this.setState({ disabled: false });
                this.props.close(true);

            }).catch((error) => {
                this.setState({ disabled: false });
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
            });

    }

    render() {
        let {
            disabled,
            isEmailSignatureRawHtml,
            emailSignature,
        } = this.state;

        const {
           config,
           loggedIn,
           currentCase,
        } = this.props;

        return (
            <ConfirmDialog title='Default Email Signature'
                           cancel={() => {this.props.close(false)}}
                           confirm={this.confirm}
                           open={this.props.open}
                           size='lg'>
                <Row>
                    <Col xs={12}>
                        <CheckBox field={{
                                      name: 'htmlCheckbox'
                                  }}
                                  disabled={disabled}
                                  checked={isEmailSignatureRawHtml}
                                  label='Raw HTML (Advanced)'
                                  help='If checked, allows for custom HTML code to be inserted, creating more complex signatures. Will reset the signature to empty signature.'
                                  onChange={elem => {
                                    isEmailSignatureRawHtml = !isEmailSignatureRawHtml;
                                    emailSignature = '';
                                    this.setState({emailSignature, isEmailSignatureRawHtml});
                                  }} />
                    </Col>
                    <Col xs={12}>
                        {isEmailSignatureRawHtml ?
                        (<TextArea field={{
                                        name: 'htmlSignature',
                                        touched: true,
                                        value: emailSignature,
                                        onChange: evt => {
                                            let value = evt.target.value;
                                            this.setState({emailSignature: value});
                                        }
                                   }}
                                   forceFullSize={true}
                                   disabled={disabled}
                                   label='Signature'
                                   rows={10}
                                   name='Signature'
                                   help='This signature will be added at the end of your every email.' />)
                            :
                        (<TextEditor field={{
                                         name: 'editor',
                                         touched: true,
                                         value: emailSignature,
                                         onChange: value => {
                                             this.setState({emailSignature: value});
                                         }
                                     }}
                                     label='Signature'
                                     help='This signature will be added at the end of your every email.'
                                     rows={10}
                                     disabled={disabled}
                                     isEmail={true}
                                     currentConfig={config}
                                     currentCase={currentCase}
                                     loggedIn={loggedIn} />)
                        }
                    </Col>
                </Row>
            </ConfirmDialog>
        );
    }
}

EmailSignatureDialog.propTypes = {
    close: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
    return {
        config: state.user.config,
        loggedIn: state.user.loggedIn,
        currentCase: state.cases.current,
    };
};

export default connect(mapStateToProps)(EmailSignatureDialog);
